exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lineContainer .input_line{border-radius:10px;background-color:#fff;border:2px solid #005380;margin-top:10px;float:left}.lineComponent{height:100px;float:left;display:inline-block;width:100%}.textSizesContainer select{width:90%}.line_title{height:20px;font-family:SourceSansPro;font-size:16px;color:#005380;width:100%;float:left}.textSizesContainer{width:25%;text-align:center;float:left;display:inline-block;margin:10px 0 0}.lineContainer .line{float:left;width:100%;display:inline-block}.subNote{height:24px;font-family:SourceSansPro-It;font-size:13px;font-weight:400;font-style:normal;font-stretch:normal;line-height:1.85;letter-spacing:normal;text-align:left;color:#009de0}.red{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ca22cc4a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Line.vue
// module id = 99
// module chunks = 0